import Materialize from 'materialize-css';
import doc_ready from 'document-ready';

function copy2clip(trigger) {
    var target = trigger.dataset.target;
    var copyTextarea = document.getElementById(target);

    if (!copyTextarea) {
        Materialize.toast('Target mancante', 4000);
        return;
    }
    copyTextarea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        Materialize.toast({html:'<span>La selezione è stata copiata</span>', displayLength: 4000});
        setTimeout(function () {
            Materialize.toast({ html:'<span>Puoi incollarla dove vuoi premendo CTRL+V</span>'});
        }, 1000);
    } catch (err) {
        Materialize.toast({html:'<span>Non sono riuscito a copiare la selezione</span>'});
    }
}

function copy2clipboard () {
    doc_ready( () => {
        // Textarea copy to clipboard function
        var copyTextareaBtn = document.getElementsByClassName('copy2clip');
        for (var i = 0; i < copyTextareaBtn.length; i++) {
            copyTextareaBtn[i].addEventListener('click', function (event) {copy2clip(this);});
        }
    })
}

export default copy2clipboard;